import { SignalGeneratorClass } from "../types";
import {
  ContentEditableChangeGenerator,
  MutationChangeGenerator,
  OnChangeGenerator,
} from "./change-gen";
import { ClickSignalsGenerator, FormSubmitGenerator } from "./dom-gen";
import { OnNavigationEventGenerator } from "./navigation-gen";

export const domGenerators: SignalGeneratorClass[] = [
  MutationChangeGenerator,
  OnChangeGenerator,
  ContentEditableChangeGenerator,
  ClickSignalsGenerator,
  FormSubmitGenerator,
  OnNavigationEventGenerator,
];
